import React from "react";
import Table from "./mockTestTable";
import data from "./mockTestTableData";
import { useStores } from "../../store";
export default function MockTestAnalytics() {
    const { MockStore } = useStores();
    // useEffect(() => {
    //     console.log(toJS(MockStore?.report), "this is the report");
    // }, []);
    return (
        <div className="mt-9"> 
           <h1 style={{fontSize:"2rem" ,color:"#FF6B00"}}>Analytics by Topic</h1>
            <Table data={data} />

            <div className="mx-auto mt-5 w-[100%]">
                <h1 className="text-2xl font-semibold mb-4 text-primary">MCQ Questions</h1>

                {MockStore?.report?.mcqs.map((item, index) => (
                    <div key={item._id} className="mb-4 border rounded p-4 shadow-md">
                        <p className="font-semibold">Question {index + 1}:</p>
                        <p>{item.mcq.question}</p>

                        <div className="mt-2">
                            <p className="font-semibold">Options:</p>
                            <ul>
                            {Object.entries(item.mcq.options).map(([optionKey, optionValue]) => (
                                <li key={optionKey} className="ml-4">
                                {optionKey}: {optionValue}
                                </li>
                            ))}
                            </ul>
                        </div>

                        <p className="mt-2">
                            <span className="font-semibold">Your Answer:</span> {item.selectedOption}
                        </p>
                        <p>
                            <span className="font-semibold">Correct Answer:</span> {item.mcq.answer}
                        </p>
                        <p>
                            <span className="font-semibold">Category:</span> {item.mcq.category}
                        </p>
                    </div>
                ))}
            </div>

        </div>
    )
}